import { render } from "./FormDelivery.vue?vue&type=template&id=364bfcf0"
import script from "./FormDelivery.vue?vue&type=script&lang=ts"
export * from "./FormDelivery.vue?vue&type=script&lang=ts"
script.render = render

export default script